
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons'

import { useTranslation } from '@flecto/translations'

import { PageError } from '../PageError/PageError'

export function PageError500() {
  const { t } = useTranslation('store', { keyPrefix: 'store-shared' })

  return (
    <PageError
      icon={faExclamationTriangle}
      title={t('page_500.title')}
      description={t('page_500.description')}
      actionLabel={t('page_500.action_label')}
      actionCallback={() => window.location.reload()}
    />
  )
}
